import { useMemo } from 'react';

import { GuardianSimple } from '@dreryk/egabinet-patient-frontend-api';
import { GuardianExternalIdentifier } from '@dreryk/egabinet-patient-published-language-api';

import { AddCircleIcon, EmptyStatePlaceholder, Link, LinkSize, Table } from '@dreryk/react-components';

import { guardiansTranslationKeys } from '../../../../../translations';

import { useGuardianMarkAsRemovedCommand, useGuardiansTableColumnConfiguration } from './GuardiansTable.hooks';

type GuardiansTableProps = {
   readonly guardians?: GuardianSimple[];
   readonly onEdit: (guardianId: number, guardianIdentifier: GuardianExternalIdentifier) => void;
   readonly onGuardianDeleted: () => Promise<void>;
   readonly onAddGuardian: VoidFunction;
};

export const GuardiansTable = (props: GuardiansTableProps): JSX.Element => {
   const { guardians } = props;
   const { executeAsync: removeGuardian } = useGuardianMarkAsRemovedCommand(props.onGuardianDeleted);
   const columnsConfiguration = useGuardiansTableColumnConfiguration(props.onEdit, removeGuardian);
   const dataConfiguration = useMemo(
      () => ({
         data: guardians ?? [],
      }),
      [guardians]
   );
   return (
      <Table
         testId='guardians'
         keyExtractor={'id'}
         columns={columnsConfiguration}
         dataConfiguration={dataConfiguration}
         placeholder={
            <EmptyStatePlaceholder
               heading={guardiansTranslationKeys.noGuardians}
               subheading={guardiansTranslationKeys.noGuardiansAssignedToPatient}
               testId={'noGuardians'}
            >
               <Link
                  testId={'addGuardian'}
                  label={guardiansTranslationKeys.addGuardian}
                  onClick={props.onAddGuardian}
               />
            </EmptyStatePlaceholder>
         }
         bottomElement={
            props.guardians?.length ? (
               <Link
                  testId='addGuardian'
                  label={guardiansTranslationKeys.addGuardian}
                  onClick={props.onAddGuardian}
                  icon={<AddCircleIcon />}
                  size={LinkSize.NORMAL}
               />
            ) : undefined
         }
      />
   );
};
